export const AssignmentTypes = {
  anyAdvizers: {
    id: "anyAdvizers",
    label: "Any Advizers",
    description: ({ requiredCount }: { requiredCount: number }) =>
      `Students find and watch any ${requiredCount} Advizer interviews they want`,
    defaultTitle: "Career Exploration Assignment",
    defaultInstructions: `Find some professionals (Advizers) that resonate with you, watch their interview videos and answer the reflection questions.`,
    defaultRequiredCount: 3,
  },
  anyPlaylists: {
    id: "anyPlaylists",
    label: "Any Playlists",
    description: ({ requiredCount }: { requiredCount: number }) =>
      `Students find and complete any ${requiredCount} career learning playlists they want`,
    defaultTitle: "Career Exploration Assignment",
    defaultInstructions: `Find some career learning playlists that resonate with you, watch them and answer the reflection questions.`,
    defaultRequiredCount: 3,
  },
  specificPlaylists: {
    id: "specificPlaylists",
    label: "Specific Playlists",
    description: () =>
      `Students watch career learning playlists that you assign`,
    defaultTitle: "Career Exploration Assignment",
    defaultInstructions: `Watch the assigned playlists and answer the reflection questions.`,
    defaultRequiredCount: null,
  },
};
